var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdianti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 48.915 48.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.012 -0.018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.873,1.423l-.41,32.1L39.486,42.2l.346-31.257L17.873,1.423Z",
    transform: "translate(-0.012 -0.018)",
    fill: "green"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.149,73.146l.426-33.326L39.82,54.655,40.2,84.59Z",
    transform: "translate(-39.261 -39.261)",
    fill: "#95ff80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.375,39.82l-.426,33.326,23.136,9.12.359-32.44Z",
    transform: "translate(-1186.062 -39.261)",
    fill: "#62d85e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.728,2413.68,69.82,2425.092l0,.093,11.6,2.944,8.371-5.024,10.675,5.045,8.395-5.35Z",
    transform: "translate(-68.84 -2379.795)",
    fill: "#47c44c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.089,1697.08l-13.839,10.073,22.815,8.72Z",
    transform: "translate(-1188.33 -1673.255)",
    fill: "rgba(206,255,194,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.43,143.5l15.128-10.834.391-32.306Z",
    transform: "translate(-94.09 -98.951)",
    fill: "#ceffc2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdianti);
export default __webpack_public_path__ + "static/media/adianti.e1a8e743b8d294c6e2c71499f3b69d19.svg";
export { ForwardRef as ReactComponent };